import { render, staticRenderFns } from "./leftListT.vue?vue&type=template&id=c40bc6fe&scoped=true&"
import script from "./leftListT.vue?vue&type=script&lang=js&"
export * from "./leftListT.vue?vue&type=script&lang=js&"
import style0 from "./leftListT.vue?vue&type=style&index=0&id=c40bc6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40bc6fe",
  null
  
)

export default component.exports